Core.ReportsRouter = Core.SubRouter.extend({
    routes: {
        '': 'reports',
        'summary': 'summary',
        'mine': 'myReports',
        'all': 'allReports',
        'templates': 'reportTemplates',
        'user:id': 'userReports',
        'customer:id': 'customerReports',
        'customerproject:id': 'customerProjectReports',
        'order:id': 'orderReports',
        'new': 'newReport',
        'new-absence': 'newAbsenceReport',
        'new/user:id': 'reportForUser',
        'job/:jobId/user/:userId': 'reportJob',
        'job/:jobId': 'reportJob',
        ':id/edit': 'editReport',
        ':id': 'viewReport',
    },

    reports: function () {
        debug.log('reports');
        var view = new WorkReportListView({scrolling: true});
        view.fetchList();
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    myReports: function () {
        debug.log('myReports');
        var view = new WorkReportListView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    allReports: function () {
        debug.log('allReports');
        var view = new WorkReportListView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    reportTemplates: function () {
        debug.log('reportTemplates');
        var view = new WorkReportListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    userReports: function (id) {
        debug.log('userReports');
        var view = new WorkReportListView({temporary: true, scrolling: true});
        view.fetchList('user/'+id);
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    customerReports: function () {
        debug.log('customerReports');
        var view = new WorkReportListView({temporary: true, scrolling: true});
        view.fetchList('customer/'+id);
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    customerProjectReports: function () {
        debug.log('customerProjectReports');
        var view = new WorkReportListView({temporary: true, scrolling: true});
        view.fetchList('customerProject/'+id);
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    orderReports: function () {
        debug.log('orderReports');
        var view = new WorkReportListView({temporary: true, scrolling: true});
        view.fetchList('order/'+id);
        app.setMainView(view, 'reports', { wideContainer: true});
    },

    summary: function () {
        debug.log('reports summary');
        app.setMainView(new WorkReportSummaryView(), 'reports');
    },

    newReport: function () {
        debug.log('new report');
        var view = new ReportDetailsView({editing: true});
        view.setModel(new WorkReport());
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reports');
    },

    newAbsenceReport: function () {
        debug.log('new absence report');
        var view = new ReportDetailsView({editing: true});
        view.setModel(new WorkReport({type: 'ABSENCE'}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reports');
    },

    reportForUser: function (userId) {
        debug.log('report for user ' + userId);
        var view = new ReportDetailsView({editing: true});
        view.setModel(new WorkReport({userId: userId}));
        app.setMainView(view, 'reports');
    },

    reportJob: function (jobId, userId) {
        debug.log('report job ' + jobId + (userId ? ' for user ' + userId : ''));
        var view = new ReportDetailsView({editing: true});
        view.saveAction = '#jobs/' + jobId;
        var template = new WorkReport();
        template.url = Core.contextRoot + '/workreport/template-for-job/' + jobId + (userId ? '?userId=' + userId : '');
        template.fetch().success(function () {
            var model = new WorkReport(template.toJSON());
            if (userId) model.set('userId', userId);
            view.setModel(model, { nodefaults: true });
            app.setMainView(view, 'reports');
        }).error(function(response) {
            errorResponse(response.responseText);
        });
    },

    editReport: function (id) {
        debug.log('view report ' + id);
        var view = new ReportDetailsView({editing: true});
        if (view.model.id != id) view.setModel(new WorkReport({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reports');
    },

    viewReport: function (id) {
        debug.log('view report ' + id);
        var view = new ReportDetailsView({editing: false});
        if (view.model.id != id) view.setModel(new WorkReport({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'reports');
    },

});
